import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-select/dist/react-select.css';
import "react-table/react-table.css";
import 'react-datepicker/dist/react-datepicker.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import config from './config';

// REDUX
import { Provider } from 'react-redux';
import store from './store/store';

// Cognito
import Amplify from 'aws-amplify';

Amplify.configure({
  Auth: config.cognito
});

let path;

if (process.env.REACT_APP_USER_TYPE === 'admin'){
	path = '/admin';
}
else if (process.env.REACT_APP_USER_TYPE === 'caterer'){
	path = '/caterer';
} 

ReactDOM.render(
	<Provider store={store}>
		{ path ?
			<BrowserRouter basename={`${path}`}>
				<div>
					<App />
				</div>
			</BrowserRouter>
			:
			<BrowserRouter>
				<div>
					<App />
				</div>
			</BrowserRouter>
		}
	</Provider>,
	 document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
